import { computed, onBeforeMount, ref } from 'vue'
import type { RechercheStore } from '@/features/interface/recherches/shared/composables/storeRechercheBuilder.ts'
import { storeToRefs } from 'pinia'
import { objectIsEmpty } from '@/features/interface/shared/tools'

export function useShowFilter(store: RechercheStore<any, any>) {
  const showFilters = ref(false)
  const { pageRequest } = storeToRefs(store)
  const { setupCustomUpdater } = store

  const isAdvancedFiltered = computed(() => {
    const {search, ...query } = pageRequest.value?.query
    return !objectIsEmpty(query)
  })
  const executeRemoveFilters = setupCustomUpdater<void>((pageRequest) => {
    pageRequest.query = {}
  })

  async function removeFilters() {
    await executeRemoveFilters()
    showFilters.value = false
  }

  onBeforeMount(() => {
    if (isAdvancedFiltered.value) {
      showFilters.value = true
    }
  })
  return { showFilters, removeFilters, isAdvancedFiltered }
}
